import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { Link } from "react-router-dom";

const FinalInvitation = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReducedMotion) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });

    tl.from(section.querySelectorAll(".animate-in"), {
      opacity: 0,
      scale: 0.95,
      y: 20,
      stagger: 0.2,
      duration: 1,
      ease: "power3.out",
    });

    gsap.to(section, {
      background: "linear-gradient(135deg, #4A5D23, #6A822D)",
      scrollTrigger: {
        trigger: section,
        start: "top center",
        end: "bottom center",
        scrub: true,
      },
    });

    return () => {
      gsap.killTweensOf(section);
      if (tl) tl.kill();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-nature-green-dark py-20 text-white md:py-24"
    >
      <div className="mx-auto max-w-4xl px-6 text-center">
        <h2 className="animate-in font-serif text-3xl font-semibold md:text-4xl">
          Together, We Are Stronger
        </h2>
        <p className="animate-in mx-auto mt-4 max-w-2xl text-lg text-stone-200">
          Join a legacy of unity. Find your place, share your strength, and help
          write the next chapter of our village's story.
        </p>
        <div className="animate-in mt-8">
          <Link to="/register">
            <button className="rounded-full bg-amber-400 px-8 py-3 text-lg font-bold text-nature-green-dark transition-transform duration-300 hover:scale-105">
              Join the Community
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalInvitation;
